import styles from './HomePage.module.css';
import Reservation from '../../components/reservation/Reservation';
import React, { useState } from 'react';
import Splash from '../../components/splash/Splash';
import { Footer } from 'abu-common-components';
import classnames from 'classnames';

const HomePage = () => {
  const [splashContentContainer, setSplashContentContainer] = useState(false);
  const [showSplashContentBoxDiv, setShowSplashContentBoxDiv] = useState(false);
  const splashContainerClassName = classnames(styles.mainSplashContainer, {
    [styles.removeSplashContent]: splashContentContainer
  });
  const mainReservationClassName = classnames(styles.mainReservationContainer, {
    [styles.mainReservationContainerBorder]: splashContentContainer
  });
  const splashContentBoxDivHandler = (flag: boolean) => {
    setShowSplashContentBoxDiv(flag);
  };

  return (
    <div className={styles.homeGridContainer} data-testid="homePageTestId">
      <main>
        {showSplashContentBoxDiv && (
          <div className={splashContainerClassName}>
            <Splash />
          </div>
        )}
        <div className={mainReservationClassName}>
          <Reservation
            deActiveSplashContent={setSplashContentContainer}
            splashContentBoxHandler={splashContentBoxDivHandler}
          />
        </div>
      </main>
      {showSplashContentBoxDiv && (
        <footer>
          <div className={styles.footerContainer}>
            <Footer />
          </div>
        </footer>
      )}
    </div>
  );
};

export default HomePage;
